var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":_vm.processing ? 'grey lighten-1' : _vm.color,"rounded":"","type":_vm.type},on:{"click":_vm.submit}},[(_vm.processing)?[_c('i',{staticClass:"fas fa-spinner fa-spin"})]:[_vm._v(" "+_vm._s(_vm.label)+" ")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }